import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import CapitalNeedsPage from './pages/CapitalNeedsPage';
import CapitalNeedPage from './pages/CapitalNeedPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <CapitalNeedsPage />,
  },
  {
    path: 'new',
    element: <CapitalNeedPage />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <CapitalNeedPage />,
      },
    ],
  },
];

export default routes;
